import { useCallback, useState } from "react";
import {
  FiltersContext,
  FiltersDataContext,
  SetFiltersContext,
  UpdateFiltersDataContext,
} from "./hooks/FiltersContext";

const FiltersProvider = FiltersContext.Provider;
const SetFiltersProvider = SetFiltersContext.Provider;
const FiltersDataProvider = FiltersDataContext.Provider;
const UpdateFiltersDataProvider = UpdateFiltersDataContext.Provider;

export default function FiltersContainer({ children }) {
  const [filters, setFilters] = useState({});
  const [filtersData, setFiltersData] = useState(null);

  const handleSetFilters = useCallback((newFilters) => {
    setFilters(newFilters);
  }, []);

  const handleUpdateFiltersData = useCallback((data) => {
    setFiltersData(data);
  }, []);

  return (
    <SetFiltersProvider value={handleSetFilters}>
      <UpdateFiltersDataProvider value={handleUpdateFiltersData}>
        <FiltersDataProvider value={filtersData}>
          <FiltersProvider value={filters}>{children}</FiltersProvider>
        </FiltersDataProvider>
      </UpdateFiltersDataProvider>
    </SetFiltersProvider>
  );
}
